import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {

  storeLectureVideo ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('lecture/storeLectureVideo', obj,
        {
          onUploadProgress: function (progressEvent) {
            state.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
          }.bind(this) })
        .then(response => {
          state.uploadPercentage = 0
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  updateLectureVideo ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('lecture/updateLectureVideo', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  deleteLectureVideo ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('lecture/deleteLectureVideo', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  storeChapterScript ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('file/storeChapterScript', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  getLectureListByChapterId ({ state, commit }, chapterId) {
    axios.get('lecture/getLecturelistByChapterId/' + chapterId)
      .then(response => {
        state.lectureList = response.data
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },

  getScriptlistByChapterId ({ state, commit }, chapterId) {
    axios.get('script/getScriptlistByChapterId/' + chapterId)
      .then(response => {
        state.scriptList = response.data
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getCourseDetails ({ state, commit }, id) {
    axios.get('course/courseDetail/' + id)
      .then(response => {
        console.log(response.data)
        state.courseDetail = response.data
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getCourseSubjectList ({ state, commit }, id) {
    axios.get('course/getSubjectlistByCourseId/' + id)
      .then(response => {
        state.courseSubjectList = response.data
        commit('setCourseSubjectList', response.data)
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getSubjectListNotInCourse ({ state, commit }, id) {
    axios.get('course/getSubjectListNotInCourse/' + id)
      .then(response => {
        state.subjectListNotInCourse = response.data
        commit('setSubjectListNotInCourse', response.data)
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getChapterNameListBySubjectId ({ state, commit }, obj, subjectId) {
    axios.get('course/getChapterNameListBySubjectId/' + obj.courseId + '/' + obj.subjectId)
      .then(response => {
        state.chapterList = response.data
        console.log(response.data)
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  storeChapter ({ state, commit }, obj) {
    console.log(obj)
    return new Promise((resolve, reject) => {
      axios.post('chapter/storeChapter', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  storeChapterExam ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('exam/storeChapterExam', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  getExamListByChapter ({ state, commit }, id) {
    axios.get('chapter/getExamListByChapter/' + id)
      .then(response => {
        state.examList = response.data
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getLectureDetails ({ state, commit }, id) {
    axios.get('lecture/getLectureDetails/' + id)
      .then(response => {
        state.lectureDetails = response.data
        console.log(response.data)
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  storeLectureScript ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('file/storeLectureScript', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },

  getScriptlistByLectureId ({ state, commit }, lectureId) {
    axios.get('script/getScriptlistByLectureId/' + lectureId)
      .then(response => {
        state.lectureScriptList = response.data
        console.log(response.data)
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  storeLectureExam ({ state }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('exam/storeLectureExam', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  },
  getExamListByLecture ({ state, commit }, id) {
    axios.get('lecture/getExamListByLecture/' + id)
      .then(response => {
        state.lectureExamList = response.data
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getChapterDetailsChapterId ({ state }, id) {
    axios.get('chapter/getChapterDetailsChapterId/' + id)
      .then(response => {
        state.chapterDetail = response.data
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  }

}
